const USDDecimal = 8;
export default USDDecimal;
